export const enTranslations = {
  // Header
  "logo": "Gabriela Nowakowska",
  "nav": {
    "about": "About",
    "experience": "Experience",
    "publications": "Publications",
    "teaching": "Teaching",
    "contact": "Contact"
  },
  
  // Hero
  "hero": {
    "badge": "Assistant Professor",
    "titlePrefix": "",
    "titleName": "Gabriela Nowakowska,",
    "titleSuffix": "PhD",
    "subtitle": "Adam Mickiewicz University",
    "description": "I have a PhD in computer science and love combining theory with practical applications. Right now, I'm working with Allegro through Laniqo, focusing on machine translation for e-commerce – basically making global shopping easier and more accessible. Before that, I worked at Snowflake (ex-Applica) on document understanding, turning unstructured data into something useful. My research has been featured at international conferences, and what excites me most is solving real-world problems with NLP, ML, and AI.",
    "contactBtn": "Contact Me",
    "publicationsBtn": "View Publications"
  },
  
  // Experience
  "experience": {
    "title": "Education & Experience",
    "workTitle": "Work Experience",
    "educationTitle": "Education",
    "present": "Present",
    "labels": {
      "supervisor": "Supervisor:",
      "defenseDate": "Defense date:",
      "showAbstract": "Show Abstract",
      "hideAbstract": "Hide Abstract"
    },
    "work1": {
      "title": "Senior Machine Learning Developer",
      "company": "Laniqo",
      "description": "Research and development in Product Intelligence for e-commerce, focusing on product knowledge, confidence, and search relevance. Responsibilities include developing Allegro's AI Shopping Assistant to drive conversational discovery, as well as previously building e-commerce machine translation solutions through model training, evaluation, and prompt engineering."
    },
    "work1Allegro": {
      "title": "Senior MT Research Scientist",
      "company": "Allegro",
      "description": "Research and development in Product Intelligence for e-commerce, focusing on product knowledge, confidence, and search relevance. Responsibilities include developing Allegro's AI Shopping Assistant to drive conversational discovery, as well as previously building e-commerce machine translation solutions through model training, evaluation, and prompt engineering."
    },
    "work2": {
      "title": "Research Scientist",
      "company": "Snowflake (ex-Applica)",
      "description": "Research and development in information extraction from business documents. Developed models to extract data into lists and tables from long documents, and built a dataset management system to streamline data preparation and organization."
    },
    "work3": {
      "title": "Deep Learning Specialist",
      "company": "Applica",
      "description": "Research and development in information extraction from business documents. Developed models for extracting data from structured (e.g., lists, tables), unstructured (raw text), and graphical elements (e.g., signatures, stamps, checkboxes), prepared training, testing, and validation datasets, and conducted experiments to evaluate and optimize model performance."
    },
    "edu1": {
      "title": "PhD in Computer Science",
      "institution": "Adam Mickiewicz University",
      "titleEn": "Named entity recognition and information extraction from various documents",
      "titlePl": "Rozpoznawanie jednostek nazwanych i ekstrakcja informacji z dokumentów różnego typu",
      "supervisor": "prof. UAM dr hab. Tomasz Górecki",
      "defenseDate": "January 14, 2025"
    },
    "edu2": {
      "title": "Master's in Computer Science",
      "institution": "Adam Mickiewicz University",
      "titleEn": "Query expansion using language models",
      "titlePl": "Rozszerzanie zapytań przy użyciu modeli języka",
      "supervisor": "prof. UAM dr hab. Filip Graliński",
      "defenseDate": "June 30, 2020"
    },
    "edu3": {
      "title": "Bachelor's in Computer Science",
      "institution": "Adam Mickiewicz University",
      "titleEn": "Conference Management System - application for simplifying the process of creating and managing conferences",
      "titlePl": "System Obsługi Konferencji - Aplikacja wspomagająca tworzenie i uczestniczenie w konferencjach",
      "supervisor": "prof. UAM dr hab. Krzysztof Dyczkowski",
      "defenseDate": "February 13, 2019"
    },
    "eduMathMaster": {
      "title": "Master's in Mathematics",
      "institution": "Adam Mickiewicz University",
      "titleEn": "Computability concept formalizations",
      "titlePl": "Formalizacje pojęcia obliczalności",
      "supervisor": "prof. UAM dr hab. Izabela Bondecka-Krzykowska",
      "defenseDate": "July 9, 2019"
    },
    "eduMathBachelor": {
      "title": "Bachelor's in Mathematics",
      "institution": "Adam Mickiewicz University",
      "titleEn": "Łukasiewicz logic as an example of many valued logic",
      "titlePl": "Logika Łukasiewicza jako przykład logiki wielowartościowej",
      "supervisor": "prof. UAM dr hab. Izabela Bondecka-Krzykowska",
      "defenseDate": "July 3, 2017"
    }
  },
  
  // Publications
  "publications": {
    "title": "Publications",
    "labels": {
      "authors": "Authors:",
      "venue": "Venue:",
      "doi": "DOI:",
      "url": "URL:",
      "date": "Date:",
      "showAbstract": "Show Abstract",
      "hideAbstract": "Hide Abstract"
    }
  },
  
  // Teaching
  "teaching": {
    "title": "Teaching",
    "course1": {
      "title": "Formal Languages and Computational Complexity",
      "polish": "Języki formalne i złożoność obliczeniowa",
      "linkLabel": "Języki formalne i złożoność obliczeniowa (lab.) (2026/SL) (G. Nowakowska)",
      "description": "Lab sessions (computer lab) focus on practical applications of finite automata in programming — implementing regular expressions, designing parsers, and representing automata in code structures. Students learn to apply formal computational models to real-world programming tasks."
    },
    "course2": {
      "title": "Machine Learning",
      "polish": "Uczenie maszynowe",
      "linkLabelNew": "Uczenie maszynowe (lab.) (2026/SZ) (G. Nowakowska)",
      "linkLabel": "Uczenie maszynowe (lab.) (2025/SZ) (D. Filipiak, D. Ewald, G. Nowakowska)",
      "description": "Lab sessions focus on practical implementation of machine learning algorithms in Python using NumPy, PyTorch, and Scikit-Learn. Students implement linear and logistic regression, evaluation and cross-validation methods, unsupervised learning algorithms, and neural networks. The course concludes with an individual programming project."
    }
  },
  
  // Contact
  "contact": {
    "title": "Contact",
    "email": "Email: gabriela.nowakowska@amu.edu.pl",
    "emailLabel": "Email",
    "consultationTitle": "Student Consultation Hours",
    "consultation1": "• Tuesdays: 12:00-13:00 (in person) - please send a message beforehand, otherwise I might be in a different part of the building",
    "consultation2": "• The second time slot is flexible - please send an email and we'll schedule a consultation (online consultation via Microsoft Teams <i class=\"fas fa-video\" style=\"color: #6264A7;\"></i> also available)",
    "orcid": "ORCID: 0000-0002-5139-2126"
  },
  
  // Page title
  "pageTitle": "Gabriela Nowakowska | Assistant Professor",
  "pageTitleExperience": "Experience | Gabriela Nowakowska",
  "pageTitlePublications": "Publications | Gabriela Nowakowska",

  // Footer
  "footer": {
    "copyright": "Gabriela Nowakowska. All rights reserved.",
    "university": "Adam Mickiewicz University"
  }
}; 